export default "__VITE_ASSET__CdWRJQW$__"